import React from 'react';

import PropTypes from 'prop-types';
import { Button, Emoji, HTML } from 'components';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const ResultForm = (props) => {
  const {
    title,
    emojiName,
    titleIcon,
    content,
    btnText,
    onBtnClick,
  } = props;

  return (
    <div className={cx('wrapper')}>
      <div className={cx('errorIconWrap')}>
        {emojiName && (
          <Emoji className={cx('errorIcon')} name={emojiName} />
        )}
        {titleIcon && (
          <img className={cx('errorIcon')} src={titleIcon} alt="" />
        )}
      </div>
      <HTML as="div" className={cx('errorTitle')}>{title}</HTML>
      <HTML as="div" className={cx('errorDescription')}>{content}</HTML>

      <div className={cx('btnWrap')}>
        <Button
          type="button"
          className="big"
          onClick={onBtnClick}
          wide
        >
          <HTML>{btnText}</HTML>
        </Button>
      </div>
    </div>
  );
};

ResultForm.propTypes = {
  title: PropTypes.string,
  emojiName: PropTypes.string,
  titleIcon: PropTypes.string,
  content: PropTypes.string,
  btnText: PropTypes.string,
  onBtnClick: PropTypes.func,
};

export default ResultForm;
